module.exports = __webpack_public_path__ + "img/building.bf1464bd.svg";